import { Helmet } from 'react-helmet-async';

interface CollectionPageSchemaProps {
  name: string;
  description: string;
  url: string;
  totalItems?: number;
}

const CollectionPageSchema = ({ name, description, url, totalItems }: CollectionPageSchemaProps) => {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name,
    description,
    url,
    mainEntity: {
      '@type': 'ItemList',
      numberOfItems: totalItems,
    },
    isPartOf: {
      '@type': 'WebSite',
      name: 'SeniorThrive',
      url: 'https://seniorthrive.com',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://seniorthrive.com/',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Blog',
          item: 'https://seniorthrive.com/blog',
        },
      ],
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default CollectionPageSchema;